var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgU(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.145,
    height: 29.729,
    viewBox: "0 0 23.145 29.729",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#4aa5ff",
    d: "M460.173-85.44h-23.122c-.021.021 0 3.3 0 3.3v26.429l11.561-4.955 11.561 4.955V-82.14s.027-3.229 0-3.3zM452.8-70.483c0 3.055-1.558 4.808-4.274 4.808-2.6 0-4.088-1.732-4.088-4.751v-6.32h2.462v6.346c0 1.139.289 2.5 1.662 2.5.436 0 1.762 0 1.762-2.5v-6.349h2.476z",
    transform: "translate(-437.042 85.44)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgU);
export default __webpack_public_path__ + "static/media/U.f7618cc779d6aae92baf554f2b2bc4b6.svg";
export { ForwardRef as ReactComponent };